const WIDTH = /preview/.test(location.pathname) ? 375 : document.documentElement.clientWidth;

export default class Proto {
  constructor({count, config}) {
	this.count = count;
	this.config = {...config};
  }

  // 计算组件全部加载完的高度
  get totalHeight() {
	const {goods_margin: margin, goods_list_style} = this.config;
	let count = this.count;
	switch (goods_list_style) {
	  case 0 : // 大图
		return count * (this.imageHeight + this.largeInfoHeight + margin);
	  case 1: // 一行两个
		return Math.ceil(count / 2) * (this.smallImageHeight + this.smallInfoHeight + margin);
	  case 2: // 列表
		return count * (this.imageHeight + this.smallInfoHeight + margin);
	  case 3: // 一大两小
		const row_num = Math.ceil(count / 3);
		// 如果除以3有余数,小行数量是大行数量+1,否则一样
		let offset = (count % 3 === 2) ? 1 : 0;
		const small_row = Math.floor(count / 3) + offset;
		return row_num * (this.imageHeight + this.largeInfoHeight + margin) + small_row * (this.smallImageHeight + this.smallInfoHeight + margin);
	}
  }

  // 计算总商品数量

  // 图片高度
  get imageHeight() {
	if (this.config.goods_list_style === 2) return 120;
	const ratio = [0.6667, 1, 1.33, 0.5625][this.config.image_scale];
	const width = WIDTH - this.config.page_margin * 2;
	return width * ratio;
  }

  // 小图片高度
  get smallImageHeight() {
	const ratio = [0.6667, 1, 0.133, 0.5625][this.config.image_scale];
	const width = WIDTH - (this.config.page_margin * 2) - this.config.goods_margin;
	return (width / 2) * ratio;
  }

  // 一行两个时的info高度
  get smallInfoHeight() {
	return this.infoHeight;
  }

  // 一行一个时的info高度
  get largeInfoHeight() {
	return this.infoHeight;
  }

  // 文字高度
  get infoHeight() {
	return 0;
  }
}
